import { render } from "./AsideLeft.vue?vue&type=template&id=5b04a44e"
import script from "./AsideLeft.vue?vue&type=script&lang=js"
export * from "./AsideLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__